import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

export const getListingsService = createAsyncThunk(
  "listings/getListingsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.listingsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createListingsService = createAsyncThunk(
  "listings/createListingsService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.listingsURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateListingsService = createAsyncThunk(
  "listings/updateListingsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.listingsURL}/${params?.id}`,
        params.formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE FUEL SERVICE
export const deleteListingsService = createAsyncThunk(
  "listings/deleteListingsService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.listingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE => UPDATE Listinigs SERVICE
export const updateListinigsService = createAsyncThunk(
  "listings/updateListinigsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.listingsURL}/${params?.id}`,
        params.formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
export const getListingsByIdService = createAsyncThunk(
  "listings/getListingsByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.listingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
